import { render } from "./FollowupReminderSettings.vue?vue&type=template&id=e7da01d0"
import script from "./FollowupReminderSettings.vue?vue&type=script&lang=js"
export * from "./FollowupReminderSettings.vue?vue&type=script&lang=js"

import exportComponent from "/home/paiscaler-travelcrmdev/htdocs/travelcrmdev.paiscaler.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__